module.exports = __webpack_public_path__ + "static/media/clearspace-min.4f1d50fa.svg";